// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__22xP4","footer":"ReportModalFilter_footer__3Soiu"};